<template>
  <div v-if="selectedReservation">
    <div class="modal fade" role="dialog" ref="reservationrepricemodal">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new">
            <div class="row">
              <div class="col-sm-10">
                <h4>Provider Reprice</h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <!-- <div hidden="hidden">
                    Selected Transaction Data <br />
                    Service Type: {{ selectedReservation.serviceType }} <br />
                    Id: {{ selectedReservation.reservationId }} <br />
                    Provider Id: {{ selectedReservation.providerId }} <br />
                    Class Name: {{ selectedReservation.className }} <br />
                    Vehicle Brand: {{ selectedReservation.vehicleBrand }} <br />
                    Vehicle Factory: {{ selectedReservation.vehicleFactory }} <br />
                    Reservation Code: {{ selectedReservation.code }} <br />
                    Company Name: {{ selectedReservation.companyName }} <br />
                    Customer Name: {{ selectedReservation.customerName }} <br />
                    Driver Name: {{ selectedReservation.driverName }} <br />
                    Last State: {{ selectedReservation.lastState }} <br />
                    Payment Status: {{ selectedReservation.paymentStatus }} <br />
                    Progress: {{ selectedReservation.progress }} <br />
                    Total: {{ selectedReservation.currencyCode }}
                    {{ selectedReservation.grandTotal }} <br />
                    Grand Total: {{ selectedReservation.stringGrandTotal }} <br />
                    <br />
                    Reservation Detail Data <br />
                    Pickup Location: {{ reservationDetail.pickUpLocation.address }} <br />
                    Drop Off Location: {{ reservationDetail.dropOffLocation.address }}
                    <br />
                    Pick Up Date: {{ reservationDetail.pickUpDate.stringFullDate }} <br />
                    Drop Off Date: {{ reservationDetail.dropOffDate.stringFullDate }}
                    <br />

                    Reservation Date:
                    {{ reservationDetail.reservationDate.stringFullDate }} <br />
                    Booker: <br />
                    Name: {{ reservationDetail.booker.fullName }} <br />
                    Phone: {{ reservationDetail.booker.phoneCode }} -
                    {{ reservationDetail.booker.phoneNumber }} <br />

                    Fare Components Selling: <br />
                    {{ this.reservationDetail.fareComponentsSelling }} <br />
                    Fare Components Buying: <br />
                    {{ this.reservationDetail.fareComponentsBuying }} <br />
                    Passenger: <br />
                    {{ reservationDetail.passengers }} <br />
                    Histories: <br />
                    {{ reservationDetail.histories }} <br />
                  </div> -->

                  <!-- Start: Form -->
                  <div class="row">
                    <div class="col-sm-6">
                      <!-- <h4>
                        Provider Reservation Reprice
                        <span class="text-edited" v-if="isUpdate"></span>
                      </h4> -->

                      <div style="margin-bottom: 20px">
                        <div>
                          <!-- <nav aria-label="breadcrumb">
                            <ol class="breadcrumb mb-35 pz">
                              <li class="breadcrumb-item">
                                <router-link :to="'/job/provider'"> Provider Job </router-link>
                              </li>
                              <li class="breadcrumb-item active" aria-current="page">Detail</li>
                            </ol>
                          </nav> -->
                          <!-- <div class="table-legend">
                            <ul>
                              <li v-if="isAirportTransfer">
                                <i class="ic-flight-icon"></i>Airport Transfer
                              </li>
                              <li v-else><i class="ic-time"></i>Hourly Booking</li>
                            </ul>
                          </div> -->
                          <h4>Provider Jobs Detail</h4>
                          <!-- <div :class="progressClassName"></div> -->
                        </div>
                        <!-- <div class="label-group">
                          <div class="label">Payment Status</div>
                          <div class="label-title">
                            <span
                              :class="{
                                '--green35': reservationDetail.paymentStatus === 'Complete',
                                'sts-danger': reservationDetail.paymentStatus !== 'Complete',
                              }"
                              >{{ reservationDetail.paymentStatus }}</span
                            >
                          </div>
                        </div> -->
                        <!-- <div class="label-group">
                          <div class="label">Payment Method</div>
                          <div class="label-title">
                            <span>{{ humanize(reservationDetail.paymentMethod) }}</span>
                          </div>
                        </div> -->
                        <div class="label-group">
                          <div class="label">Reservation Code</div>
                          <div class="label-title">
                            <span>{{ reservationDetail.code }}</span>
                          </div>
                        </div>
                        <div class="label-group">
                          <div class="label">Reservation Date</div>
                          <div class="label-title">
                            <span>{{
                              reservationDetail.reservationDate.stringFullDate
                            }}</span>
                          </div>
                        </div>
                        <div
                          class="label-group"
                          v-if="reservationDetail.driver"
                        >
                          <div class="label">Driver Name</div>
                          <div class="label-title --blue25">
                            <span
                              >{{ reservationDetail.driver.title }}.
                              {{ reservationDetail.driver.fullName }}</span
                            >
                          </div>
                        </div>
                        <div
                          class="label-group"
                          v-if="reservationDetail.driver"
                        >
                          <div class="label">Driver Phone</div>
                          <div class="label-title">
                            <span>{{
                              reservationDetail.driver.phoneCode &&
                              reservationDetail.driver.phoneNumber
                                ? `(+${reservationDetail.driver.phoneCode}) ${reservationDetail.driver.phoneNumber}`
                                : "N/A"
                            }}</span>
                          </div>
                        </div>
                      </div>

                      <span><strong>Pre-booking Components</strong></span>
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th class="number">No</th>
                            <th>Name</th>
                            <th>Category</th>
                            <th>
                              <label>
                                Rate
                                <span
                                  class="--grey50"
                                  v-if="!isDifferentCurrency"
                                >
                                  ({{ currencyCode }})
                                </span>
                                <span
                                  class="--grey50"
                                  v-if="isDifferentCurrency"
                                >
                                  ({{ equivalentCurrencyCode }})
                                </span>
                              </label>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              item, index
                            ) in reservationDetail.fareComponentsPreBooking"
                            :key="item.name"
                          >
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.category }}</td>
                            <td class="text-right" v-if="!isDifferentCurrency">
                              {{ printMoney(item.rate) }}
                            </td>
                            <td class="text-right" v-if="isDifferentCurrency">
                              {{ printMoney(item.equivalentRate) }}
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Sub Total</td>
                            <td></td>
                            <td class="text-right" v-if="!isDifferentCurrency">
                              {{
                                printMoney(reservationDetail.buyingGrandTotal)
                              }}
                            </td>
                            <td class="text-right" v-if="isDifferentCurrency">
                              {{
                                printMoney(
                                  reservationDetail.equivalentBuyingGrandTotal
                                )
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-sm-6">
                      <span>Add or Update extra service</span>
                      <h6>Please fill all information below.</h6>
                      <form
                        role="form"
                        action="#"
                        id="master-class-rental-rate-form"
                      >
                        <div class="row">
                          <div class="col-sm-12 prz">
                            <div class="form-group">
                              <label class="required">Extra Service</label>
                              <select
                                class="form-control v-select"
                                name="type"
                                v-model="newFareComponent.name"
                                v-on:change="changeAncillaryItem($event)"
                                required
                              >
                                <option value>- Please Select -</option>
                                <option
                                  v-for="item in postbookingAncillaries"
                                  :value="item.name"
                                  :key="item.name"
                                >
                                  {{ item.name }}
                                </option>
                              </select>
                              <small
                                class="form-text text-danger"
                                v-if="validationErrors.type"
                                v-text="validationErrors.type"
                              ></small>
                            </div>
                          </div>
                          <div class="col-sm-6" hidden="hidden">
                            <div class="form-group">
                              <label class="required">Rate</label>
                              <input
                                class="form-control"
                                type="number"
                                name="duration"
                                v-model="newFareComponent.rate"
                                placeholder="100"
                                min="0"
                                required
                              />
                              <small
                                class="form-text text-danger"
                                v-if="validationErrors.duration"
                                v-text="validationErrors.duration"
                              ></small>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6 prz" hidden="hidden">
                            <div class="form-group">
                              <label class="required">
                                Quantity
                                <span
                                  class="--grey50"
                                  v-if="!isDifferentCurrency"
                                >
                                  ({{ currencyCode }})
                                </span>
                                <span
                                  class="--grey50"
                                  v-if="isDifferentCurrency"
                                >
                                  ({{ equivalentCurrencyCode }})
                                </span>
                              </label>
                              <input
                                class="form-control"
                                type="number"
                                name="rate"
                                v-model="newFareComponent.quantity"
                                placeholder="Enter quantity"
                                @change="calculateAncillaryTotal()"
                                min="1"
                                step="any"
                                required
                              />
                              <small
                                class="form-text text-danger"
                                v-if="validationErrors.rate"
                                v-text="validationErrors.rate"
                              ></small>
                            </div>
                          </div>
                          <div class="col-sm-12 prz">
                            <label class="required">
                              Price
                              <span
                                class="--grey50"
                                v-if="!isDifferentCurrency"
                              >
                                ({{ currencyCode }})
                              </span>
                              <span class="--grey50" v-if="isDifferentCurrency">
                                ({{ equivalentCurrencyCode }})
                              </span>
                            </label>
                            <input
                              class="form-control"
                              type="number"
                              name="extra_rate"
                              v-model="newFareComponent.rate"
                              placeholder="Enter price"
                              min="0"
                              step="any"
                              required
                            />
                            <small
                              class="form-text text-danger"
                              v-if="validationErrors.extra_rate"
                              v-text="validationErrors.extra_rate"
                            ></small>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-default"
                            @click.prevent="reset()"
                          >
                            Reset
                          </button>
                          <button
                            v-if="!isUpdate && isCanPropose()"
                            type="submit"
                            class="btn btn-primary"
                            @click.prevent="createItem()"
                          >
                            Create
                          </button>
                          <button
                            v-if="isUpdate"
                            type="submit"
                            class="btn btn-primary"
                            @click.prevent="updateItem()"
                          >
                            Update
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!-- End: Form -->

                  <!-- Start: Table -->
                  <br />
                  <div class="table-modal-detail">
                    <div class="table-responsive table-accordion">
                      <span><strong>Extra Services</strong></span>
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <!-- <th class="number">No</th> -->
                            <th>Name</th>
                            <th class="text-right">
                              <label> Quantity / Time </label>
                            </th>
                            <th class="text-right">
                              <label>
                                Rate
                                <span
                                  class="--grey50"
                                  v-if="!isDifferentCurrency"
                                >
                                  ({{ currencyCode }})
                                </span>
                                <span
                                  class="--grey50"
                                  v-if="isDifferentCurrency"
                                >
                                  ({{ equivalentCurrencyCode }})
                                </span>
                              </label>
                            </th>
                            <th class="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(groupId, index) in fareGroupIds">
                            <tr
                              v-for="fare in getFareById(groupId)"
                              :key="fare.id"
                              v-bind:style="{
                                'background-color': getColor(index),
                              }"
                            >
                              <!-- <td class="text-center">{{ index + 1 }}</td> -->
                              <td>{{ fare.name }}</td>
                              <td class="text-right">{{ fare.quantity }}</td>
                              <td
                                class="text-right"
                                v-if="!isDifferentCurrency"
                              >
                                {{ printMoney(fare.rate) }}
                              </td>
                              <td class="text-right" v-if="isDifferentCurrency">
                                {{ printMoney(fare.equivalentRate) }}
                              </td>
                              <td class="text-center">
                                <div class="button-action-wrapper">
                                  <button
                                    v-if="isCanPropose()"
                                    class="btn btn-default"
                                    type="button"
                                    @click="bindModel(fare)"
                                  >
                                    <span>Edit</span>
                                  </button>
                                  <button
                                    v-if="isCanPropose()"
                                    class="btn btn-default"
                                    type="button"
                                    @click="confirmDelete(fare)"
                                  >
                                    <i class="ic-close"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </template>
                          <tr v-for="item in getNonGroupFare()" :key="item.id">
                            <!-- <td class="text-center">{{ index + 1 }}</td> -->
                            <td>{{ item.name }}</td>
                            <td class="text-right">{{ item.quantity }}</td>
                            <td class="text-right" v-if="!isDifferentCurrency">
                              {{ printMoney(item.rate) }}
                            </td>
                            <td class="text-right" v-if="isDifferentCurrency">
                              {{ printMoney(item.equivalentRate) }}
                            </td>
                            <td class="text-center">
                              <div class="button-action-wrapper">
                                <button
                                  v-if="isCanPropose()"
                                  class="btn btn-default"
                                  type="button"
                                  @click="bindModel(item)"
                                >
                                  <span>Edit</span>
                                </button>
                                <button
                                  v-if="isCanPropose()"
                                  class="btn btn-default"
                                  type="button"
                                  @click="showEvidences(item)"
                                >
                                  <span>Evidences</span>
                                </button>
                                <button
                                  v-if="isCanPropose()"
                                  class="btn btn-default"
                                  type="button"
                                  @click="confirmDelete(item)"
                                >
                                  <i class="ic-close"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>Sub Total</td>
                            <td class="text-right" v-if="!isDifferentCurrency">
                              {{ printMoney(totalExtraService) }}
                            </td>
                            <td class="text-right" v-if="isDifferentCurrency">
                              {{ printMoney(equivalentTotalExtraService) }}
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br />

                    <div
                      v-if="showEvidence"
                      class="table-responsive table-accordion"
                    >
                      <span>Evidences</span>
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in selectedEvidences"
                            :key="item.id"
                          >
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>{{ getEvidenceName(item) }}</td>
                            <td>
                              <!-- <button
                                v-if="isCanPropose()"
                                class="btn btn-default"
                                type="button"
                                @click="bindModel(item)"
                              > -->
                              <button
                                class="btn btn-default"
                                type="button"
                                @click="getImage(item)"
                              >
                                <span>Show</span>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br />

                    <div>
                      <span>Total Cost</span>
                      <table class="table">
                        <thead>
                          <tr>
                            <th class="text-right">
                              <label>
                                Grand Total
                                <span
                                  class="--grey50"
                                  v-if="!isDifferentCurrency"
                                >
                                  ({{ currencyCode }})
                                </span>
                                <span
                                  class="--grey50"
                                  v-if="isDifferentCurrency"
                                >
                                  ({{ equivalentCurrencyCode }})
                                </span>
                              </label>
                            </th>
                            <!-- <th class="text-right">
                              <label>
                                Remaining
                                <span class="--grey50"
                                  >({{ reservationDetail.currencyCode }})</span
                                >
                              </label>
                            </th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-right" v-if="!isDifferentCurrency">
                              {{ printMoney(totalCost) }}
                            </td>
                            <td class="text-right" v-if="isDifferentCurrency">
                              {{ printMoney(equivalentTotalCost) }}
                            </td>
                            <!-- <td class="text-right">{{ totalExtraService }}</td> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- End: Table -->
                  <!-- <div>
                    <span v-if="!isCanPropose()" style="color:red">
                      (Waiting for Controller/Admin review)
                    </span>
                  </div> -->
                  <div>
                    <button
                      v-if="!isUpdate && isCanSubmit()"
                      type="submit"
                      class="btn btn-primary"
                      @click.prevent="submit()"
                    >
                      SUBMIT
                    </button>
                    <!-- <button
                      v-if="!isUpdate && isCanReprice()"
                      type="submit"
                      class="btn btn-primary"
                      @click.prevent="reprice()"
                    >
                      REPRICE
                    </button> -->
                    <!-- <button
                      v-if="!isUpdate && !isInvoiced()"
                      type="submit"
                      class="btn btn-primary"
                      @click.prevent="publishInvoice()"
                    >
                      INVOICE
                    </button> -->
                    <!-- <button
                      v-if="isInvoiced()"
                      type="submit"
                      class="btn btn-danger"
                      @click.prevent="close()"
                    >
                      CLOSE
                    </button> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import numeral from "numeral";
import inquiryProviderJobService from "@/services/job/providerJob/inquiryProviderJobService.js";
import inquiryReservationService from "@/services/shop/reservation/inquiryReservationService.js";
import depositSummaryService from "@/services/master/deposit/depositSummaryService.js";
import extraService from "@/services/master/sellingTariff/sellingTariffAncillaryRateService.js";
import { constants } from "zlib";

export default {
  data() {
    return {
      isLoading: false,
      selectedReservation: {},
      reservationDetail: {
        booker: {},
        serviceType: "",
        code: "",
        driver: {},
        moneyFormat: {
          cultureCode: "en-SG",
          currencyCode: "SGD",
          decimalFormat: "0,0.00",
          decimalSeparator: ".",
          numberOfDecimal: 2,
          thousandSeparator: ",",
        },
        reservationDate: { stringFullDate: "" },
        passengers: [],
        pickUpDate: {},
        pickUpLocation: {},
        dropOffDate: {},
        dropOffLocation: {},
        className: "",
        paymentStatus: "",
        currencyCode: "",
        grandTotal: "",
        buyingGrandTotal: "",
        equivalentBuyingGrandTotal: "",
        histories: [],
        fareComponents: [],
        fareComponentsSelling: [],
        fareComponentsBuying: [],
        fareComponentsPreBooking: [],
        fareComponentsPostBooking: [],
      },
      postbookingAncillaries: [],
      originalAncillaries: [],
      selectedAncillary: {},
      newFareComponent: {
        id: "",
        name: "",
        masterClassAncillaryId: "",
        quantity: 1,
      },
      fareGroupIds: [],
      newFareTotal: 0,
      isUpdate: false,
      showEvidence: false,
      model: {},
      totalCost: 0,
      equivalentTotalCost: 0,
      currencyCode: "",
      equivalentCurrencyCode: "",
      isDifferentCurrency: false,
      totalExtraService: 0,
      equivalentTotalExtraService: 0,
      selectedEvidences: [],
      validationErrors: {
        type: null,
        duration: null,
        rate: null,
        extra_rate: null,
      },
      msg: "Please wait",
    };
  },
  created() {
    // subscribe message
    this.$eventBus.$on("initializeReservationReprice", this.initialize);
    this.$eventBus.$on("deleteFareComponent", this.deleteItem);
    this.$eventBus.$on("openModalReservationReprice", this.openModal);
  },
  updated() {
    const self = this;
    $("#startPeriod-rental-wrapper .datepicker-day").on("click", function () {
      self.minimumEndPeriod = self.model.startPeriod;
    });
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeReservationReprice");
    this.$eventBus.$off("deleteFareComponent");
    this.$eventBus.$off("openModalReservationReprice");
  },
  methods: {
    openModal() {
      $(this.$refs.reservationrepricemodal).modal();
      $(this.$refs.reservationrepricemodal).css("overflow-y", "auto");
    },
    closeModal() {
      $(this.$refs.reservationrepricemodal).modal("hide");
    },
    async initialize(item) {
      try {
        this.isLoading = true;
        this.reset();
        this.selectedReservation = item;
        await this.getAll();
        this.openModal();
      } finally {
        this.isLoading = false;
      }
    },
    resetValidation() {
      this.validationErrors.type = null;
      this.validationErrors.duration = null;
      this.validationErrors.rate = null;
      this.validationErrors.extra_rate = null;
    },
    bindModel(object) {
      this.reset();
      this.selectedAncillary = this.postbookingAncillaries.find(
        (a) => a.name == object.name
      );
      if (this.selectedAncillary == null) {
        this.selectedAncillary = {
          name: object.name,
        };
        this.postbookingAncillaries.push({
          name: object.name,
        });
      }
      this.isUpdate = true;
      this.resetValidation();
      this.model = Object.assign({}, object);
      this.newFareComponent.id = object.id;
      this.newFareComponent.name = this.selectedAncillary.name;
      if (!this.isDifferentCurrency) {
        this.newFareComponent.rate = object.rate;
      } else {
        this.newFareComponent.rate = object.equivalentRate;
      }
      this.newFareComponent.quantity = object.quantity;
      this.calculateAncillaryTotal();
    },
    reset() {
      this.postbookingAncillaries = this.originalAncillaries;
      this.isUpdate = false;
      this.resetValidation();
      this.model = {};
      this.newFareComponent = {
        id: "",
        masterClassAncillaryId: "",
        quantity: 1,
      };
      this.newFareTotal = 0;
    },
    async getAll() {
      // const response = await inquiryReservationService.getById(
      //   this.selectedReservation.reservationId
      // );
      const response = await inquiryProviderJobService.getDetail(
        this.selectedReservation.reservationId
      );
      if (response != null) {
        this.moneyFormat = response.moneyFormat;
        this.reservationDetail.booker = response.booker;
        this.reservationDetail.driver = response.driver;
        this.reservationDetail.histories = response.histories;
        this.reservationDetail.pickUpLocation = response.pickUpLocation;
        this.reservationDetail.dropOffLocation = response.dropOffLocation;
        this.reservationDetail.pickUpDate = response.pickUpDate;
        this.reservationDetail.dropOffDate = response.dropOffDate;
        this.reservationDetail.code = response.code;
        // this.reservationDetail.className = response.className;
        this.reservationDetail.serviceType = response.serviceType;
        this.reservationDetail.reservationDate = response.reservationDate;
        // this.reservationDetail.passengers = response.passengers;
        this.reservationDetail.paymentStatus = response.paymentStatus;
        this.reservationDetail.currencyCode = response.moneyFormat.currencyCode;
        this.reservationDetail.grandTotal = response.grandTotal;
        this.reservationDetail.histories = response.histories;
        this.reservationDetail.fareComponents = response.fareComponents;

        let existBuyingFare = this.reservationDetail.fareComponents.filter(
          (x) => x.category === "Buying"
        );
        if (
          existBuyingFare[0].equivalentCurrencyCode != null &&
          existBuyingFare[0].equivalentCurrencyCode != "" &&
          existBuyingFare[0].equivalentCurrencyCode !=
            response.moneyFormat.currencyCode
        ) {
          this.equivalentCurrencyCode =
            existBuyingFare[0].equivalentCurrencyCode;
          this.isDifferentCurrency = true;
        }

        if (
          this.reservationDetail.fareComponents != null &&
          this.reservationDetail.fareComponents.length > 0
        ) {
          var fareComponents = Array.prototype.slice.call(
            this.reservationDetail.fareComponents,
            0
          );
          this.reservationDetail.fareComponentsPreBooking =
            fareComponents.filter(
              (f) => f.category == "Buying" && f.isPreBooking
            );
          this.reservationDetail.buyingGrandTotal =
            this.reservationDetail.fareComponentsPreBooking.reduce(
              (a, b) => a + (b["rate"] || 0),
              0
            );
          if (this.isDifferentCurrency) {
            this.reservationDetail.equivalentBuyingGrandTotal =
              this.reservationDetail.fareComponentsPreBooking.reduce(
                (a, b) => a + (b["equivalentRate"] || 0),
                0
              );
          }
          this.reservationDetail.fareComponentsPostBooking =
            fareComponents.filter(
              (f) => f.category == "Buying" && !f.isPreBooking
            );

          this.fareGroupIds =
            this.reservationDetail.fareComponentsPostBooking.map(
              (a) => a.groupId
            );
          this.fareGroupIds = [...new Set(this.fareGroupIds)];
          var index = this.fareGroupIds.indexOf(null);
          this.fareGroupIds.splice(index, 1);
        }
        this.calculateTotal();
      }
      const ancillaries = await extraService.getExtraServices();
      this.postbookingAncillaries = ancillaries;
      this.originalAncillaries = ancillaries;
    },
    getFareById(groupId) {
      const result = this.reservationDetail.fareComponentsPostBooking.filter(
        (fare) => fare.groupId == groupId
      );

      return result;
    },
    getNonGroupFare() {
      const result = this.reservationDetail.fareComponentsPostBooking.filter(
        (fare) => fare.groupId == null
      );

      return result;
    },
    getColor(index) {
      if (index % 2 == 0) {
        return "lightgrey";
      } else return "aliceblue";
    },
    showEvidences(item) {
      this.selectedEvidences = item.evidences;
      this.showEvidence = true;
    },
    changeAncillaryItem(event) {
      this.selectedAncillary = this.postbookingAncillaries.find(
        (a) => a.name == event.target.value
      );
      this.newFareComponent.name = this.selectedAncillary.name;
      this.newFareComponent.rate = this.selectedAncillary.rate;
      this.calculateAncillaryTotal();
    },
    printMoney(value) {
      return this.moneyFormat
        ? numeral(value).format(this.moneyFormat.decimalFormat)
        : value;
    },
    getEvidenceName(item) {
      // var rest = item.imageUri.substring(0, item.imageUri.lastIndexOf("/") + 1);
      var last = item.imageUri.substring(
        item.imageUri.lastIndexOf("/") + 1,
        item.imageUri.length
      );
      return last;
    },
    async getImage(item) {
      try {
        this.isLoading = true;
        const response = await inquiryProviderJobService.viewAttachment(
          item.id
        );
        window.open(response.data, "_blank");
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    calculateAncillaryTotal() {
      this.newFareTotal =
        this.newFareComponent.quantity * this.selectedAncillary.rate;
    },
    calculateTotal() {
      this.totalExtraService =
        this.reservationDetail.fareComponentsPostBooking.reduce(
          (accum, item) => accum + item.quantity * item.rate,
          0
        );
      this.totalCost =
        this.reservationDetail.buyingGrandTotal + this.totalExtraService;

      if (this.isDifferentCurrency) {
        this.equivalentTotalExtraService =
          this.reservationDetail.fareComponentsPostBooking.reduce(
            (accum, item) => accum + item.quantity * item.equivalentRate,
            0
          );
        this.equivalentTotalCost =
          this.reservationDetail.equivalentBuyingGrandTotal +
          this.equivalentTotalExtraService;
      }
    },
    isAirportTransfer: function () {
      return (
        this.reservationDetail &&
        this.reservationDetail.serviceType !== "" &&
        this.reservationDetail.serviceType.toLowerCase() === "airporttransfer"
      );
    },
    async createItem() {
      try {
        this.isLoading = true;
        this.model.reservationId = this.selectedReservation.reservationId;
        this.newFareComponent.quantity = 1; // Number(this.newFareComponent.quantity);
        this.newFareComponent.id = null;
        this.newFareComponent.masterClassAncillaryId = null;
        this.newFareComponent.rate = Number(this.newFareComponent.rate);
        this.model.ancillaries = [this.newFareComponent];
        await inquiryProviderJobService.addPostbookingAncillary(this.model);
        this.$notification.success("Successfully added.", { title: "Success" });
        // await inquiryProviderJobService.repricePostbookingAncillary({
        //   reservationId: this.selectedReservation.reservationId,
        //   providerId: this.selectedReservation.providerId,
        // });
        // this.$notification.success("Successfully calculated", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async updateItem(item) {
      if (!this.$helper.validateForm(this, "master-class-rental-rate-form")) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.reservationId = this.selectedReservation.reservationId;
        this.newFareComponent.quantity = Number(this.newFareComponent.quantity);
        this.newFareComponent.masterClassAncillaryId = null;
        this.newFareComponent.rate = Number(this.newFareComponent.rate);
        this.model.ancillaries = [this.newFareComponent];
        await inquiryProviderJobService.updatePostbookingAncillary(this.model);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        // await inquiryProviderJobService.repricePostbookingAncillary({
        //   reservationId: this.selectedReservation.reservationId,
        //   providerId: this.selectedReservation.providerId,
        // });
        // this.$notification.success("Successfully calculated", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.closeModal();
      this.$eventBus.$emit(
        "openProviderJobBrowserDeleteModal",
        "inquiryReservationFareComponent",
        item.id
      );
    },
    async deleteItem(id) {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.deletePostbookingAncillary(id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await inquiryProviderJobService.repricePostbookingAncillary({
          reservationId: this.selectedReservation.reservationId,
          providerId: this.selectedReservation.providerId,
        });
        this.$notification.success("Successfully calculated", {
          title: "Success",
        });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.openModal();
        this.isLoading = false;
      }
    },
    isPassengerDropped: function () {
      try {
        let canApprove = false;
        canApprove =
          this.reservationDetail != null &&
          this.reservationDetail.histories != null &&
          this.reservationDetail.histories.length > 0 &&
          this.reservationDetail.histories[
            this.reservationDetail.histories.length - 1
          ].event == "PassengerDropped";
        return canApprove;
      } catch (error) {
        return false;
      }
    },
    isProposed: function () {
      try {
        let canApprove = false;
        canApprove =
          this.reservationDetail != null &&
          this.reservationDetail.histories != null &&
          this.reservationDetail.histories.length > 0 &&
          this.reservationDetail.histories[
            this.reservationDetail.histories.length - 1
          ].event == "PriceProposed";
        return canApprove;
      } catch (error) {
        return false;
      }
    },
    isApproved: function () {
      try {
        let canApprove = false;
        canApprove =
          this.reservationDetail != null &&
          this.reservationDetail.histories != null &&
          this.reservationDetail.histories.length > 0 &&
          this.reservationDetail.histories[
            this.reservationDetail.histories.length - 1
          ].event == "PriceApproved";
        return canApprove;
      } catch (error) {
        return false;
      }
    },
    isCanSubmit: function () {
      try {
        let canPropose = false;
        canPropose =
          this.isProposed() || this.isApproved() || this.isPassengerDropped();
        return canPropose;
      } catch (error) {
        return false;
      }
    },
    async submit() {
      try {
        this.isLoading = true;
        if (this.isPassengerDropped()) {
          await inquiryProviderJobService.proposePrice({
            reservationId: this.selectedReservation.reservationId,
          });
          this.$notification.success("Price Successfully Proposed.", {
            title: "Success",
          });
          await inquiryProviderJobService.approvePrice({
            reservationId: this.selectedReservation.reservationId,
          });
          this.$notification.success("Price Successfully Approved.", {
            title: "Success",
          });
          await inquiryProviderJobService.closeReservation({
            reservationId: this.selectedReservation.reservationId,
          });
          this.$notification.success("Reservation successfully closed.", {
            title: "Success",
          });
        }
        if (this.isProposed()) {
          await inquiryProviderJobService.approvePrice({
            reservationId: this.selectedReservation.reservationId,
          });
          this.$notification.success("Price Successfully Approved.", {
            title: "Success",
          });
          await inquiryProviderJobService.closeReservation({
            reservationId: this.selectedReservation.reservationId,
          });
          this.$notification.success("Reservation successfully closed.", {
            title: "Success",
          });
        }
        if (this.isApproved()) {
          await inquiryProviderJobService.closeReservation({
            reservationId: this.selectedReservation.reservationId,
          });
          this.$notification.success("Reservation successfully closed.", {
            title: "Success",
          });
        }
        this.reset();
        this.$eventBus.$emit("reloadData");
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    isCanReprice: function () {
      try {
        let canPropose = false;
        canPropose =
          this.reservationDetail != null &&
          this.reservationDetail.histories != null &&
          this.reservationDetail.histories.length > 0 &&
          (this.reservationDetail.histories[
            this.reservationDetail.histories.length - 1
          ].event == "PassengerDropped" ||
            this.reservationDetail.histories[
              this.reservationDetail.histories.length - 1
            ].event == "Repriced");
        return canPropose;
      } catch (error) {
        return false;
      }
    },
    isInvoiced: function () {
      try {
        let canApprove = false;
        canApprove =
          this.reservationDetail != null &&
          this.reservationDetail.histories != null &&
          this.reservationDetail.histories.length > 0 &&
          this.reservationDetail.histories[
            this.reservationDetail.histories.length - 1
          ].event == "Invoiced";
        return canApprove;
      } catch (error) {
        return false;
      }
    },
    async reprice() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.repricePostbookingAncillary({
          reservationId: this.selectedReservation.reservationId,
          providerId: this.selectedReservation.providerId,
          isManual: true,
        });
        this.$notification.success("Successfully Repriced.", {
          title: "Success",
        });
        this.reset();
        this.$eventBus.$emit("reloadData");
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async publishInvoice() {
      try {
        this.isLoading = true;
        // Deduct Deposit
        await depositSummaryService.inquiryRepriceDeduct({
          reservationId: this.selectedReservation.reservationId,
        });
        this.$notification.success("Deposit successfully deducted.", {
          title: "Success",
        });
        // send invoice
        await inquiryProviderJobService.publishInvoice({
          reservationId: this.selectedReservation.reservationId,
        });
        this.$notification.success("Invoice successfully published.", {
          title: "Success",
        });
        // Close Job
        await inquiryProviderJobService.closeReservation({
          reservationId: this.selectedReservation.reservationId,
        });
        this.$notification.success("Reservation successfully closed.", {
          title: "Success",
        });
        this.reset();
        // this.$eventBus.$emit("reloadData");
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async close() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.closeReservation({
          reservationId: this.selectedReservation.reservationId,
        });
        this.$notification.success("Reservation successfully closed.", {
          title: "Success",
        });
        this.reset();
        // this.$eventBus.$emit("reloadData");
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    isCanPropose: function () {
      try {
        let canPropose = false;
        canPropose =
          this.reservationDetail != null &&
          this.reservationDetail.histories != null &&
          this.reservationDetail.histories.length > 0 &&
          (this.reservationDetail.histories[
            this.reservationDetail.histories.length - 1
          ].event == "PassengerDropped" ||
            this.reservationDetail.histories[
              this.reservationDetail.histories.length - 1
            ].event == "PriceRejected");
        return canPropose;
      } catch (error) {
        return false;
      }
    },
    async propose() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.proposePrice({
          reservationId: this.selectedReservation.reservationId,
        });
        this.$notification.success("Price Successfully Proposed.", {
          title: "Success",
        });
        this.reset();
        // this.$eventBus.$emit("reloadData");
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
#startPeriod-rental-input,
#endPeriod-rental-input {
  height: 35px !important;
  min-height: 35px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/job/providerJob/ProviderReservationReprice.vue